// Billing Summary Pie Chart

import React from "react";
import ReactECharts from "echarts-for-react";

interface BillingSummaryPieChartProps {
  summaryData: Array<{
    status: string;
    [key: string]: any;
  }>;
  maxName?: string;
  maxValue?: number;
}

const BillingSummaryPieChart: React.FC<BillingSummaryPieChartProps> = ({
  summaryData,
  maxName,
  maxValue,
}) => {
  const getColor = (index: number) => {
    const colorList = ["#9CE976", "#1976d2", "#db50f2", "#FF9500"];
    return colorList[index % colorList.length];
  };

  const options = {
    tooltip: {
      trigger: "item",
      backgroundColor: "#181B25",
      borderWidth: 0,
      textStyle: {
        color: "#fff",
        fontSize: 12,
      },
      formatter: (params: any) =>
        `${params.name}: ${params.value.toLocaleString()} kWh`,
    },
    legend: {
      orient: "vertical",
      bottom: "80",
      right: "30",
      data: ["Hold", "Processed", "Failed"],
      textStyle: {
        fontFamily: "Figtree",
        fontSize: 10,
        fontWeight: 400,
        lineHeight: 11.72,
        letterSpacing: "0.02em",
        color: "#4C5269",
        textAlign: "left",
      },
      itemWidth: 15,
      itemHeight: 15,
    },
    series: [
      {
        type: "pie",
        radius: ["50%", "80%"],
        data: summaryData.reduce((acc, item, index) => {
          const found = acc.find((entry) => entry.name === item.status);
          if (found) {
            found.value += 1;
          } else {
            acc.push({
              name: item.status,
              value: 1,
              itemStyle: { color: getColor(index) },
            });
          }
          return acc;
        }, [] as any[]),
        label: {
          show: false,
        },
        emphasis: {
          itemStyle: {
            borderColor: "#fff",
            borderWidth: 2,
          },
          label: {
            show: true,
            formatter: (params: any) => `${params.name}\n${params.value}`,
            color: "#000",
          },
        },
      },
    ],
    graphic: [
      {
        type: "text",
        left: "center",
        top: "center",
        id: "centerText",
        style: {
          text: `${maxName}\n\n${maxValue?.toLocaleString()} kWh`,
          textAlign: "center",
          fill: "#000",
          font: "14px Arial",
          lineHeight: 20,
        },
        z: 100,
      },
    ],
  };

  return <ReactECharts option={options} style={{ height: "260px" }} />;
};

export default BillingSummaryPieChart;
